export default class PageDTO {
  page: number;
  rowsPerPage: number;

  constructor(page: number, rowsPerPage: number) {
    this.page = page;
    this.rowsPerPage = rowsPerPage;
  }
}
